import React from 'react';
import { cn } from '@rocco/utils/cn';

interface DashboardHeaderProps {
    title?: string;
    headerContent?: React.ReactNode;
    actions?: React.ReactNode;
    className?: string;
}

/**
 * Header component for the dashboard that shows a personalized greeting
 * Can be customized with actions and custom content
 */
export const MemberDashboardHeader: React.FC<DashboardHeaderProps> = ({
    title,
    actions,
    headerContent,
    className,
}) => {
    if (!headerContent && !title && !actions) {
        return null;
    }
    return (
        <div
            className={cn(
                'flex items-center justify-between gap-4 pb-5 pt-1',
                className
            )}
        >
            {headerContent ? (
                headerContent
            ) : (
                <span className="text-7 font-medium leading-[120%] text-gray-900 md:text-12.5 md:tracking-[-0.0625rem]">
                    {title}
                </span>
            )}
            {actions && <div className="flex items-center">{actions}</div>}
        </div>
    );
};
